import { CLIENT_HOLDINGS_REPORT_PARAMETER_FORM, HOLDINGS_REPORT_PARAMETER_FORM, REPORT_IDS, REPORT_REGISTRY, } from './report-dashboard-registry.js';
import { CLIENT_PORTFOLIO_PERFORMANCE_READ_OWN, PORTFOLIO_PERFORMANCE_LIST, } from '../operations/portfolio-performance.operations.js';
import { PORTFOLIO_PERFORMANCE_QUERY_ID, PORTFOLIO_PERFORMANCE_TABLE, } from './descriptors/portfolio-performance-table-registry.js';
export const PORTFOLIO_PERFORMANCE_REPORT_ID = 'report.portfolio.performance-nepal';
export const CLIENT_PORTFOLIO_PERFORMANCE_REPORT_ID = 'report.client.portfolio.performance-nepal';
export const PORTFOLIO_PERFORMANCE_REPORT_TYPE = 'PORTFOLIO_PERFORMANCE_NEPAL';
export const CLIENT_PORTFOLIO_PERFORMANCE_REPORT_TYPE = 'CLIENT_PORTFOLIO_PERFORMANCE_NEPAL';
export const PORTFOLIO_PERFORMANCE_REPORT_FORM_ID = 'form.reports.portfolioPerformanceParameters';
export const CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM_ID = 'form.reports.clientPortfolioPerformanceParameters';
function periodStartField(template, prefix) {
    return {
        ...template,
        id: `field.reports.${prefix}.periodStart`,
        name: 'periodStart',
        labelKey: 'reports.liveParameters.periodStart',
        helpTextKey: 'reports.liveParameters.periodStartHelp',
    };
}
function performanceForm(options) {
    const asOfField = options.base.fields.find((field) => field.name === 'asOfDate');
    if (!asOfField)
        throw new Error(`Report form ${options.base.id} is missing asOfDate`);
    const baseFields = options.removeClientSelector
        ? options.base.fields.filter((field) => field.name !== 'clientAccountId')
        : options.base.fields;
    const fields = [...baseFields, periodStartField(asOfField, options.prefix)];
    return Object.freeze({
        ...options.base,
        id: options.id,
        titleKey: 'reports.performanceParameters.title',
        descriptionKey: 'reports.performanceParameters.description',
        operationId: options.operationId,
        accessibilityLabelKey: 'a11y.form.reports.portfolioPerformance',
        fields,
        sections: [
            {
                id: `form.reports.${options.prefix}.section.parameters`,
                titleKey: 'reports.runForm.parametersSection',
                fields: fields.map((field) => field.id),
                layout: { columns: 2, gap: 16 },
            },
        ],
        actions: options.base.actions.map((action) => ({
            ...action,
            operationId: options.operationId,
            telemetryId: `${String(action.telemetryId)}.${options.prefix}`,
        })),
        submission: {
            ...options.base.submission,
            includeFields: fields.map((field) => field.id),
        },
    });
}
export const PORTFOLIO_PERFORMANCE_REPORT_FORM = performanceForm({
    base: HOLDINGS_REPORT_PARAMETER_FORM,
    id: PORTFOLIO_PERFORMANCE_REPORT_FORM_ID,
    operationId: PORTFOLIO_PERFORMANCE_LIST,
    prefix: 'portfolioPerformance',
});
export const CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM = performanceForm({
    base: CLIENT_HOLDINGS_REPORT_PARAMETER_FORM,
    id: CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM_ID,
    operationId: CLIENT_PORTFOLIO_PERFORMANCE_READ_OWN,
    prefix: 'clientPortfolioPerformance',
    removeClientSelector: true,
});
function performanceReport(options) {
    const baseReport = REPORT_REGISTRY[options.baseReportId];
    const REPORT_EXCLUDED_FIELDS = new Set([
        'capitalGainTax',
        'taxProvenanceCoveragePct',
        'missingTaxProvenanceCount',
        'nfrsEvidenceAvailable',
        'nfrsFactCount',
        'nfrsStandards',
        'nfrsMetrics',
    ]);
    const reportColumns = PORTFOLIO_PERFORMANCE_TABLE.columns.filter((column) => !REPORT_EXCLUDED_FIELDS.has(column.field));
    return Object.freeze({
        ...baseReport,
        id: options.id,
        reportType: options.reportType,
        titleKey: options.titleKey,
        descriptionKey: options.descriptionKey,
        category: 'PORTFOLIO',
        scope: options.scope,
        operationId: options.operationId,
        telemetryId: `experience.report.${options.telemetrySuffix}`,
        accessibilityLabelKey: options.titleKey,
        dataSourceId: PORTFOLIO_PERFORMANCE_QUERY_ID,
        parameterFormId: options.form.id,
        runFormId: options.form.id,
        columns: reportColumns,
        allowedFormats: ['json'],
        formats: ['json'],
        generatorId: `live.generator.${options.telemetrySuffix}`,
        executionMode: 'LIVE_QUERY',
        operationBindings: {
            listOperationId: options.operationId,
            runOperationId: options.operationId,
        },
        lineage: {
            sourceSystem: 'portfolio-performance-query',
            sourceEntities: [
                'PortfolioHolding',
                'ValuationFact',
                'RealizedGainLossFact',
                'LotDisposal',
                'MarketData',
            ],
            calculationVersion: 'portfolio-performance-v1-nepal-evidence',
        },
        implemented: true,
        auditPolicy: 'ALWAYS',
    });
}
export const PORTFOLIO_PERFORMANCE_REPORT = performanceReport({
    baseReportId: REPORT_IDS.PORTFOLIO_HOLDINGS,
    id: PORTFOLIO_PERFORMANCE_REPORT_ID,
    reportType: PORTFOLIO_PERFORMANCE_REPORT_TYPE,
    operationId: PORTFOLIO_PERFORMANCE_LIST,
    form: PORTFOLIO_PERFORMANCE_REPORT_FORM,
    scope: 'BRANCH',
    titleKey: 'reports.types.portfolioPerformanceNepal',
    descriptionKey: 'reports.descriptions.portfolioPerformanceNepal',
    telemetrySuffix: 'portfolioPerformanceNepal',
});
export const CLIENT_PORTFOLIO_PERFORMANCE_REPORT = performanceReport({
    baseReportId: REPORT_IDS.CLIENT_HOLDINGS,
    id: CLIENT_PORTFOLIO_PERFORMANCE_REPORT_ID,
    reportType: CLIENT_PORTFOLIO_PERFORMANCE_REPORT_TYPE,
    operationId: CLIENT_PORTFOLIO_PERFORMANCE_READ_OWN,
    form: CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM,
    scope: 'CLIENT',
    titleKey: 'reports.types.clientPortfolioPerformanceNepal',
    descriptionKey: 'reports.descriptions.clientPortfolioPerformanceNepal',
    telemetrySuffix: 'clientPortfolioPerformanceNepal',
});
export const PORTFOLIO_PERFORMANCE_REPORT_REGISTRY = Object.freeze({
    [PORTFOLIO_PERFORMANCE_REPORT_ID]: PORTFOLIO_PERFORMANCE_REPORT,
    [CLIENT_PORTFOLIO_PERFORMANCE_REPORT_ID]: CLIENT_PORTFOLIO_PERFORMANCE_REPORT,
});
export const PORTFOLIO_PERFORMANCE_REPORT_FORMS = Object.freeze({
    [PORTFOLIO_PERFORMANCE_REPORT_FORM.id]: PORTFOLIO_PERFORMANCE_REPORT_FORM,
    [CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM.id]: CLIENT_PORTFOLIO_PERFORMANCE_REPORT_FORM,
});
